import styles from './PlaybookCard.module.css'
import { Skeleton } from '@/components/ui/skeleton'

export function PlaybookCardSkeleton() {
  return (
    <div className={styles.skeleton} data-testid="playbook-card-skeleton">
      {/* Header: Number + Content */}
      <div className={styles.skeletonHeader}>
        {/* Number placeholder */}
        <Skeleton className="h-[50px] w-[30px] rounded-md" />

        <div className={styles.skeletonContent}>
          {/* Tag + Menu row */}
          <div className={styles.skeletonTagRow}>
            <Skeleton className="h-6 w-24 rounded-full" />
            <Skeleton className="h-4 w-4 rounded-full" />
          </div>

          {/* Title */}
          <Skeleton className="h-5 w-3/4" />
        </div>
      </div>

      {/* Thumbnail */}
      <div className={styles.skeletonThumbnail}>
        <Skeleton className="w-full h-full" />
      </div>

      {/* Action Pill */}
      <Skeleton className="h-6 w-full rounded-[19px]" />
    </div>
  )
}
